import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import TerminCreateUpdate from '../../../module/Admin/Termin/CreateUpdate';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import routes from '../../../routing/routes';
import useTezaurusDetail from '../../../hooks/useTezaurusDetail';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';

const AdminTerminCreatePage = (): ReactElement => {
  const { pathname } = useLocation();
  const { uuid } = useParams<{ uuid: string }>();
  const {
    tezaurus,
    tezaurusStatus,
  } = useTezaurusDetail(uuid);

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-title',
      title: 'Nový termín',
    }, '*');
  }, []);

  return (
    <Layout>
      <Loader loading={tezaurusStatus?.loading}>
        <Breadcrumbs routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.tezaurus.admin.list,
            heading: 'Administrácia tezaurov',
          },
          {
            to: routes.tezaurus.admin.termin.list.withParams(uuid),
            heading: tezaurus?.nazov || 'Zoznam termínov',
          },
          {
            to: pathname,
            heading: 'Nový termín',
          },
        ]}
        />
      </Loader>
      <GlobalErrors />
      <SecuredPage
        allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
        requestStatus={tezaurusStatus?.responseCode}
      >
        <>
          <PageHeadingWithBackButton heading="Nový termín" />
          <TerminCreateUpdate mode="CREATE" />
        </>
      </SecuredPage>
    </Layout>
  );
};

export default AdminTerminCreatePage;
